import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/up-yong-logo.png'


const _withScopeId = n => (_pushScopeId("data-v-042cdc11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-wrap bx" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-wrap" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo-h5",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("p", null, "上进青年App"),
    /*#__PURE__*/_createElementVNode("p", { class: "des" }, "跑步读书上进习惯养成社区")
  ])
], -1))

interface EmitsType {
  (e: 'download'): void;
}

export default /*#__PURE__*/_defineComponent({
  emits: ["download"],
  setup(__props, { emit }: { emit: ({
  (e: 'download'): void;
}), expose: any, slots: any, attrs: any }) {



const goDownLoad = () => {
  emit('download');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: "btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goDownLoad()))
    }, "下载App")
  ]))
}
}

})